import React, { useEffect, useState } from 'react';
import { useNavigate, NavLink, Link } from "react-router";
import '../Component/index.css';
import './mobileNav.css';
import useRateResolver from '../Component/useRateResolver';

const Header = () => {
    const { showExpo, expoStripVisible, setExpoStripVisible } = useRateResolver();
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);

    // Lock background scroll while the mobile menu is open
    useEffect(() => {
        document.body.style.overflow = menuOpen ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [menuOpen]);

    const [showSoon, setShowSoon] = useState(false);
    const closeMenu = () => setMenuOpen(false);

    const handleAboutUsClick = (e) => {
        e.preventDefault();
        setShowSoon(true);
        setTimeout(() => setShowSoon(false), 1800);
    };

    const scrollToTop = (page) => {
        navigate('/' + page);
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional: for smooth scroll animation
        });
    };

    return (
        <>
            <div className='body-div'>
                {showExpo && expoStripVisible && (
                    <div className="expo-strip" id="expoStrip">
                        <div className="wrap">
                            <p>
                                <b>Twigaa is landing at Magical Kenya Travel Expo</b>
                                <span className="dot">·</span>6–8 October 2026, Nairobi
                                <span className="dot">·</span><span className="stall">Stall A15</span>
                            </p>
                            <a className="go"
                               onClick={() =>
                                    window.gtag_report_conversion()
                                }
                                href="https://forms.gle/eGjJvF7DgLsmaLPLA"
                                target="_blank"
                                rel="noopener noreferrer"
                            >Book a meeting →</a>
                        </div>
                        <button className="x" type="button" aria-label="Dismiss announcement" onClick={() => setExpoStripVisible(false)}>×</button>
                    </div>
                )}
                <header>
                    <div className="bar">
                        <Link className="brand" to="/"><img src="./img/next_logo.png" alt="Twigaa.ai" /></Link>

                        <nav className={`top${menuOpen ? ' mobile-open' : ''}`}>
                            <NavLink to="/" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")} >Home</NavLink>
                            <NavLink to="/faq" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")} >FAQs</NavLink>
                            <NavLink to="/pricing-plans" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")} >Pricing</NavLink>
                            <NavLink to="/blog" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")} >Blog</NavLink>
                            <NavLink to="/about-us" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")} >About Us</NavLink>
                            <a className="btn btn-solid text-dark"
                                onClick={() =>
                                        window.gtag_report_conversion()
                                    }
                                href="https://forms.gle/GsaFJ4kCVUuUEftq5"
                                rel="noopener noreferrer"
                                target='_blank'
                                style={{ padding: "9px 20px", fontSize: ".86rem" }}
                            >Book a demo</a>

                            <a className="btn btn-amber text-dark"
                                onClick={() =>
                                        window.gtag_report_conversion()
                                    }
                                href="https://travelplans.twigaa.ai/login"
                                rel="noopener noreferrer"
                                target='_blank'
                                style={{ padding: "9px 20px", fontSize: ".86rem" }}
                            >Login/Register</a>
                            
                        </nav>

                        <button
                            type="button"
                            className={`menu-toggle${menuOpen ? ' is-open' : ''}`}
                            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
                            aria-expanded={menuOpen}
                            onClick={() => setMenuOpen((v) => !v)}
                        >
                            <span />
                            <span />
                            <span />
                        </button>
                    </div>
                </header>

                {menuOpen && <div className="menu-backdrop" onClick={closeMenu} />}
            </div>
        </>
    );
};

export default Header;